import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Inject, EventEmitter, Output } from '@angular/core';
import { ActiviteService } from 'src/app/shared/services/simple/activite.service';
import { ActiviteModel, ActiviteNode } from 'src/app/shared/models/simple-types/activite.model';
import { GestionActiviteComponent } from 'src/app/core/gestion-referentiel/gestion-activite/gestion-activite.component';
import { FamilleModel } from 'src/app/shared/models/simple-types/famille.model';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { CategorieModel } from 'src/app/shared/models/simple-types/categorie.model';
import { ModalInfoOkComponent } from '../info-ok/modal-info-ok.component';
import { CategorieService } from 'src/app/shared/services/simple/categorie.service';
import { ModalAddCategorieComponent } from '../modal-add-categorie/modal-add-categorie.component';
import { GestionReferentielComponentService } from 'src/app/core/gestion-referentiel/gestion-referentiel-component.service';
import { TvaModel } from 'src/app/shared/models/simple-types/tva.model';
import { TvaService } from 'src/app/shared/services/simple/tva.service';
import { SsFamilleService } from 'src/app/shared/services/simple/ss-famille.service';
import { SsFamilleModel } from 'src/app/shared/models/simple-types/ss-famille.model';
import { FamilleService } from 'src/app/shared/services/simple/famille.service';
import { ModalAddSsFamilleComponent } from '../modal-add-ss-famille/modal-add-ss-famille.component';
import { ModalAddFamilleComponent } from '../modal-add-famille/modal-add-famille.component';
import { ModalAddActiviteComponent } from '../modal-add-activite/modal-add-activite.component';

export interface DialogData {
  form: UntypedFormGroup;
  activite: ActiviteModel;
  activites: ActiviteModel[];
  result: boolean;
}
@Component({
  selector: 'app-modal-structure-activite',
  templateUrl: './modal-structure-activite.component.html',
  styleUrls: ['./modal-structure-activite.component.scss']
})
export class ModalStructureActiviteComponent implements OnInit {
  @Output() onUpdated = new EventEmitter<boolean>();
  categories: CategorieModel[] = [];
  tvas: TvaModel[] = [];
  activites: ActiviteModel[];
  form: UntypedFormGroup;
  treeControl = new NestedTreeControl<ActiviteNode>(node => node.childrens);
  dataSourceTree = new MatTreeNestedDataSource<ActiviteNode>();
  constructor(public dialog: MatDialog,
            public dialogRef: MatDialogRef<GestionActiviteComponent>,
            private gestionReferentielComponent: GestionReferentielComponentService,
            @Inject(MAT_DIALOG_DATA) public data: DialogData,
            private toastr: ToastrService,
            private categorieService: CategorieService,
            private toastrService: ToastrService,
            private tvaService: TvaService,
            private ssFamilleService: SsFamilleService,
            private familleService: FamilleService,
            private activiteService: ActiviteService) {
             }


    hasChild = (_: number, node: ActiviteNode) => !!node.childrens && node.childrens.length > 0;

    ngOnInit(): void {
      this.activites = this.data.activites;
      this.form = this.data.form;
      this.dataSourceTree.data = this.activiteService.constructActiviteTree(this.data.activite);
      this.tvaService.getAll().subscribe(tvas => {
        this.tvas = tvas;
      });
    }

    onModalCancel(): void {
      this.data.result = false;
      this.dialogRef.close(false);
    }

    onModalConfirm(): void {
      if (this.form.valid) {
        const activite = this.form.getRawValue();
        // Création
        if (!this.form.get('id').value){
          const dialogRef = this.dialog.open(SpinnerModalComponent);
            this.activiteService.save(activite).subscribe((a: ActiviteModel) => {
              this.toastr.success('', 'Création de l\'activité ' + a.code + ' réussie');
              this.dialogRef.close(true);
              dialogRef.close();
            }, (error) => {
              this.dialogRef.close(true);
              dialogRef.close();
            });
        }else { // Modification
          const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.activiteService.update(activite.id, activite).subscribe((a: ActiviteModel) => {
            this.toastr.success('', 'Modification de l\'activité ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            dialogRef.close();
          });
        }
      } else {
        this.displayErrors();
      }
   }

  add(node: ActiviteNode): void{
    switch (node.type) {
      case 'Activite':
        // add famille
        this.addFamille(node);
        break;
      case 'Famille':
        // add ss famille
        this.addSsFamille(node);
        break;
      case 'SsFamille':
        // add catégorie
        this.addCategorie(node);
        break;
    }
  }

  edit(node: ActiviteNode): void{
    switch (node.type) {
      case 'Activite':
        this.editActivite(node);
        break;
      case 'Famille':
        this.editFamille(node);
        break;
      case 'SsFamille':
        this.editSsFamille(node);
        break;
      case 'Categorie':
        this.editCategorie(node);
        break;
    }

  }
  
  delete(node: ActiviteNode): void {
    switch (node.type) {
      case 'Famille':
        this.deleteFamille(node);
        break;
      case 'SsFamille':
        this.deleteSsFamille(node);
        break;
      case 'Categorie':
        this.deleteCategorie(node);
        break;
    }
  }

  editCategorie(node: ActiviteNode): void {
    this.categorieService.get(node.id).subscribe((categorie: CategorieModel) => {
      const form = this.gestionReferentielComponent.getEditCategorieFormGroup(categorie);
      const dialogRef = this.dialog.open(ModalAddCategorieComponent, {
          autoFocus: false,
          disableClose: true,
          data: {
            form,
            tvas: this.tvas,
          }
        });
  
      dialogRef.afterClosed().subscribe(result => {
          this.onUpdated.emit(true);
          if (result) {
            let indexPParent = this.dataSourceTree.data[0].childrens.findIndex(c => c.id === node.idPParent && c.type === "Famille");
            let indexParent = this.dataSourceTree.data[0].childrens[indexPParent].childrens.findIndex(c => c.id === node.idParent && c.type === "SsFamille");
            this.dataSourceTree.data[0].childrens[indexPParent].childrens[indexParent].childrens.forEach(cat => {
              if(cat.id === result.id){
                cat.code = result.code;
                cat.libelle = result.libelle;
              }
            });
            let data = this.dataSourceTree.data
            this.dataSourceTree.data = null;
            this.dataSourceTree.data = data;
          }
      });
    })
 }

 editSsFamille(node: ActiviteNode): void {
  this.ssFamilleService.get(node.id).subscribe((ssFamille: SsFamilleModel) => {
    const form = this.gestionReferentielComponent.getEditSsFamilleFormGroup(ssFamille);
    const dialogRef = this.dialog.open(ModalAddSsFamilleComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          let indexParent = this.dataSourceTree.data[0].childrens.findIndex(c => c.id === node.idParent && c.type === "Famille");
          this.dataSourceTree.data[0].childrens[indexParent].childrens.forEach(cat => {
            if(cat.id === result.id){
              cat.code = result.code;
              cat.libelle = result.libelle;
            }
          });
          let data = this.dataSourceTree.data
          this.dataSourceTree.data = null;
          this.dataSourceTree.data = data;
        }
    });
  })
}

editFamille(node: ActiviteNode): void {
  this.familleService.get(node.id).subscribe((famille: FamilleModel) => {
    const form = this.gestionReferentielComponent.getEditFamilleFormGroup(famille);
    const dialogRef = this.dialog.open(ModalAddFamilleComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.dataSourceTree.data[0].childrens.forEach(cat => {
            if(cat.id === result.id){
              cat.code = result.code;
              cat.libelle = result.libelle;
            }
          });
          let data = this.dataSourceTree.data
          this.dataSourceTree.data = null;
          this.dataSourceTree.data = data;
        }
    });
  })
}

editActivite(node: ActiviteNode): void {
  this.activiteService.get(node.id).subscribe((activite: ActiviteModel) => {
    const form = this.gestionReferentielComponent.getEditActiviteFormGroup(activite);
    const dialogRef = this.dialog.open(ModalAddActiviteComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.dataSourceTree.data[0].libelle = result.libelle;
          let data = this.dataSourceTree.data
          this.dataSourceTree.data = null;
          this.dataSourceTree.data = data;
        }
    });
  })
}

 addCategorie(parent: ActiviteNode): void {
  const form = this.gestionReferentielComponent.getCreateCategorieFormGroup();
  form.get('idSsFamille').setValue(parent.id);
  const dialogRef = this.dialog.open(ModalAddCategorieComponent, {
      autoFocus: false,
      disableClose: true,
      data: {
        form,
        tvas: this.tvas,
      }
    });

  dialogRef.afterClosed().subscribe((result: CategorieModel) => {
      this.onUpdated.emit(true);
      if (result) {
        let node = new ActiviteNode();
        node.id = result.id;
        node.code = result.code;
        node.libelle = result.libelle;
        node.level = 4;
        node.type = "Categorie";
        node.idParent = result.idSsFamille;
        node.idPParent = parent.idParent;
        node.childrens = [];
        let indexPParent = this.dataSourceTree.data[0].childrens.findIndex(c => c.id === node.idPParent && c.type === "Famille");
        let indexParent = this.dataSourceTree.data[0].childrens[indexPParent].childrens.findIndex(c => c.id === node.idParent && c.type === "SsFamille");
        this.dataSourceTree.data[0].childrens[indexPParent].childrens[indexParent].childrens.push(node);
        let data = this.dataSourceTree.data
        this.dataSourceTree.data = null;
        this.dataSourceTree.data = data;
      }
  });
}

addSsFamille(parent: ActiviteNode): void {
  const form = this.gestionReferentielComponent.getCreateSsFamilleFormGroup();
  form.get('idFamille').setValue(parent.id);
  const dialogRef = this.dialog.open(ModalAddSsFamilleComponent, {
      autoFocus: false,
      disableClose: true,
      data: {
        form,
      }
    });

  dialogRef.afterClosed().subscribe((result: SsFamilleModel) => {
      this.onUpdated.emit(true);
      if (result) {
        let node = new ActiviteNode();
        node.id = result.id;
        node.code = result.code;
        node.libelle = result.libelle;
        node.level = 3;
        node.type = "SsFamille";
        node.idParent = result.idFamille;
        node.childrens = [];
        let indexParent = this.dataSourceTree.data[0].childrens.findIndex(c => c.id === node.idParent && c.type === "Famille");
        this.dataSourceTree.data[0].childrens[indexParent].childrens.push(node);
        let data = this.dataSourceTree.data
        this.dataSourceTree.data = null;
        this.dataSourceTree.data = data;
      }
  });
}

addFamille(parent: ActiviteNode): void {
  const form = this.gestionReferentielComponent.getCreateFamilleFormGroup();
  form.get('idActivite').setValue(parent.id);
  const dialogRef = this.dialog.open(ModalAddFamilleComponent, {
      autoFocus: false,
      disableClose: true,
      data: {
        form,
      }
    });

  dialogRef.afterClosed().subscribe((result: FamilleModel) => {
      this.onUpdated.emit(true);
      if (result) {
        let node = new ActiviteNode();
        node.id = result.id;
        node.code = result.code;
        node.libelle = result.libelle;
        node.level = 2;
        node.type = "Famille";
        node.idParent = result.idActivite;
        node.childrens = [];
        this.dataSourceTree.data[0].childrens.push(node);
        let data = this.dataSourceTree.data
        this.dataSourceTree.data = null;
        this.dataSourceTree.data = data;
      }
  });
}

 deleteCategorie(categorie){
  const dialogRef = this.dialog.open(ModalInfoOkComponent, {
    data: {
      title: 'Suppression de la categorie',
      message: 'Êtes-vous sur de vouloir supprimer la categorie ?',
      icone: 'warning_amber',
      iconColor: 'accent',
      color: 'accent'
    }
  });
  dialogRef.afterClosed().subscribe(res => {
    if (res) {
      this.categorieService.delete(categorie.id).subscribe((response: CategorieModel) => {
        this.toastrService.success('La catégorie a bien été supprimé');
        let indexPParent = this.dataSourceTree.data[0].childrens.findIndex(c => c.id === categorie.idPParent && c.type === "Famille");
        let indexParent = this.dataSourceTree.data[0].childrens[indexPParent].childrens.findIndex(c => c.id === categorie.idParent && c.type === "SsFamille");
        let index = this.dataSourceTree.data[0].childrens[indexPParent].childrens[indexParent].childrens.findIndex(c => c.id === categorie.id && c.type === "Categorie");
        if(index !== -1){
          this.dataSourceTree.data[0].childrens[indexPParent].childrens[indexParent].childrens.splice(index,1);
          let data = this.dataSourceTree.data
          this.dataSourceTree.data = null;
          this.dataSourceTree.data = data;
        }
      });
    }
  });
 }

 deleteSsFamille(ssFamille){
  const dialogRef = this.dialog.open(ModalInfoOkComponent, {
    data: {
      title: 'Suppression de la ssFamille',
      message: 'Êtes-vous sur de vouloir supprimer la ssFamille ?',
      icone: 'warning_amber',
      iconColor: 'accent',
      color: 'accent'
    }
  });
  dialogRef.afterClosed().subscribe(res => {
    if (res) {
      this.ssFamilleService.delete(ssFamille.id).subscribe((response: SsFamilleModel) => {
        this.toastrService.success('La ssFamille a bien été supprimé');
        let indexParent = this.dataSourceTree.data[0].childrens.findIndex(c => c.id === ssFamille.idParent && c.type === "Famille");
        let index = this.dataSourceTree.data[0].childrens[indexParent].childrens.findIndex(c => c.id === ssFamille.id && c.type === "SsFamille");
        if(index !== -1){
          this.dataSourceTree.data[0].childrens[indexParent].childrens.splice(index,1);
          let data = this.dataSourceTree.data
          this.dataSourceTree.data = null;
          this.dataSourceTree.data = data;
        }
      });
    }
  });
 }

 deleteFamille(famille){
  const dialogRef = this.dialog.open(ModalInfoOkComponent, {
    data: {
      title: 'Suppression de la Famille',
      message: 'Êtes-vous sur de vouloir supprimer la Famille ?',
      icone: 'warning_amber',
      iconColor: 'accent',
      color: 'accent'
    }
  });
  dialogRef.afterClosed().subscribe(res => {
    if (res) {
      this.familleService.delete(famille.id).subscribe((response: FamilleModel) => {
        this.toastrService.success('La Famille a bien été supprimé');
        let index = this.dataSourceTree.data[0].childrens.findIndex(c => c.id === famille.id && c.type === "Famille");
        if(index !== -1){
          this.dataSourceTree.data[0].childrens.splice(index,1);
          let data = this.dataSourceTree.data
          this.dataSourceTree.data = null;
          this.dataSourceTree.data = data;
        }
      });
    }
  });
 }



   displayErrors(): void {
    for (const index in this.form.controls) {
      if (index && (this.form.controls[index].hasError('required') || this.form.controls[index].hasError('max'))) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}


